import React, { useEffect, useMemo, useRef } from 'react'
import { Col, Row } from 'react-bootstrap'
import Card from '../../../../../UI/Card/Card'
import { isEmpty } from '../../../../../utils/custom_funtions'
import { prepareMathHtmlForDisplay } from '../../../../../utils/mathmlMatrixUtils'
import useMathjax, { typesetMathJaxElements } from '../../../../../hooks/useMathjax'
import styles from './RenderText.module.css';

const RenderText = (props) => {
  const rootRef = useRef(null)

  const engTextHtml = useMemo(
    () => prepareMathHtmlForDisplay(props.engText),
    [props.engText]
  )
  const hindiTextHtml = useMemo(
    () => prepareMathHtmlForDisplay(props.hindiText),
    [props.hindiText]
  )
  const engOptions = useMemo(
    () =>
      (props.engOption ?? []).map((data) => ({
        ...data,
        option: prepareMathHtmlForDisplay(data.option),
      })),
    [props.engOption]
  )
  const hindiOptions = useMemo(
    () =>
      (props.hindiOption ?? []).map((data) => ({
        ...data,
        option: prepareMathHtmlForDisplay(data.option),
      })),
    [props.hindiOption]
  )

  const mathjaxKey = useMemo(
    () =>
      [
        engTextHtml,
        hindiTextHtml,
        props.parentid,
        JSON.stringify(engOptions),
        JSON.stringify(hindiOptions),
      ].join('||'),
    [engTextHtml, hindiTextHtml, props.parentid, engOptions, hindiOptions]
  )

  useMathjax(mathjaxKey)

  useEffect(() => {
    const root = rootRef.current
    if (!root) return

    const timer = setTimeout(() => {
      typesetMathJaxElements(root)
    }, 50)

    return () => clearTimeout(timer)
  }, [mathjaxKey])

  return (
    <div ref={rootRef}>
    <Row className="my-2">
      <Col lg={6} md={12}>
        <Card className="h-100">
          {props.parentid &&
            <p>
            <b>Parent QID:</b>{props.parentid}
          </p>
          }
          <p>
            <b>{props.engTitle}:</b>
          </p>
          <div
            dangerouslySetInnerHTML={{
              __html: engTextHtml,
            }}
          ></div>
          {!isEmpty(engOptions) && (
            <>
              <p>
                <b>Options:</b>
              </p>
              <ol
                className="row justify-content-between"
                style={{
                  listStyleType: "upper-alpha",
                  marginLeft: "10px",
                }}
              >
                {engOptions.map(data => {
                  return (
                    <li
                      key={data.option_id}
                      className={`col-5 ${styles.option} ${data.is_correct == 1 && styles.correct}`}
                      dangerouslySetInnerHTML={{ __html: data.option }}
                    />
                  );
                })}
              </ol>
            </>
          )}
        </Card>
      </Col>
      <Col lg={6} md={12}>
        <Card className="h-100">
          <p>
            <b>{props.hindiTitle}:</b>
          </p>
          <div
            dangerouslySetInnerHTML={{
              __html: hindiTextHtml,
            }}
          ></div>
          {!isEmpty(hindiOptions) && (
            <>
              <p>
                <b>Options:</b>
              </p>
              <ol
                className="row justify-content-between"
                style={{
                  listStyleType: "upper-alpha",
                  marginLeft: "10px",
                }}
              >
                {hindiOptions.map(data => {
                  return (
                    <li
                      key={data.option_id}
                      className={`col-5 ${styles.option} ${data.is_correct == 1 && styles.correct}`}
                      dangerouslySetInnerHTML={{ __html: data.option }}
                    />
                  );
                })}
              </ol>
            </>
          )}
        </Card>
      </Col>
    </Row>
    </div>
  );
}

export default RenderText
